export default __webpack_public_path__ + "cffa56601f7ef04a29955e6766cb2925.png";